import { API_BASE_URL } from '../config/env';
import { clearAuthSession, getAuthToken } from './authStorage';

interface RequestOptions extends RequestInit {
  skipAuth?: boolean;
}

const buildHeaders = (input?: HeadersInit, skipAuth?: boolean): Headers => {
  const headers = new Headers(input || {});

  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  if (!skipAuth) {
    const token = getAuthToken();
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
  }

  return headers;
};

export async function apiRequest<T>(path: string, options?: RequestOptions): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: buildHeaders(options?.headers, options?.skipAuth),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    if (response.status === 401) {
      clearAuthSession();
    }

    const message = payload.error || payload.erro || payload.message || 'Erro na requisicao';
    const error: Error & { status?: number; data?: unknown; payload?: unknown } = new Error(message);
    error.status = response.status;
    error.data = payload.data;
    error.payload = payload;
    throw error;
  }

  return payload as T;
}
